// HOAD: busca avaliações de VÁRIOS produtos (as cores da mesma família) e junta
// numa lista só, sem repetir, da mais nova pra mais antiga. Uma cor é um produto
// separado neste catálogo, então sem isso cada cor "começa do zero" (23/09,
// pedido do André: avaliações por produto, pra acumular). Usa o proxy que já
// existe (/api/geral/judgeme-reviews?product_id=), uma chamada por cor.
(function () {
  if (window.HoadReviewsFamilia) return;
  var API = 'https://app.hoad.com.br';
  var MAX_IDS = 8;

  function umProduto(id, perPage) {
    return fetch(API + '/api/geral/judgeme-reviews?product_id=' + encodeURIComponent(id) + '&per_page=' + perPage)
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (d) { return d.reviews || d.data || (Array.isArray(d) ? d : []); });
  }

  window.HoadReviewsFamilia = {
    buscar: function (ids, perPage) {
      var lista = String(ids || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, MAX_IDS);
      var falhas = 0;
      return Promise.all(lista.map(function (id) {
        return umProduto(id, perPage || 30).catch(function () { falhas += 1; return []; });
      })).then(function (listas) {
        if (lista.length && falhas === lista.length) throw new Error('nenhuma coleta de avaliações funcionou');
        var vistos = {};
        var todas = [];
        listas.forEach(function (l) {
          l.forEach(function (r) {
            var chave = r.id || ((r.reviewer && r.reviewer.name) + '|' + r.created_at);
            if (vistos[chave]) return;
            vistos[chave] = true;
            todas.push(r);
          });
        });
        todas = todas.filter(function (r) { return r.published !== false; });
        todas.sort(function (a, b) { return String(b.created_at || '').localeCompare(String(a.created_at || '')); });
        return todas;
      });
    }
  };
})();
